import styled from 'styled-components';
import Progress from '@clds/progress';

const LoaderWrapper = styled.main`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  > * {
    flex: 1 1 0;
    max-width: 128px;
  }
`;

export const LoaderSpinner = () => (
  <LoaderWrapper>
    <Progress.Logo size="xxl" />
  </LoaderWrapper>
);
